import { logout } from "@/api/signUp.js";
import { removeUserId, removeUserName, removeUserType } from '@/utils/userId'
import { removeToken } from '@/utils/token.js'
import { getDicts } from '@/api/home'
import { COMPET_CODE } from '@/utils/config.js'

const user = {
  state: {
    competId: ''
  },
  mutations: {
    SET_COMPET_ID: (state, id) => {
      state.competId = id
    }
  },
  actions: {
     GetCompetId({ commit, state }) {
      return new Promise((resolve, reject) => {
        getDicts('tswl_compet_project').then((res) => {
          let { data } = res 
          let num = data.findIndex((n) => n.value == COMPET_CODE)
          if (num !== -1) {
            commit('SET_COMPET_ID', data[num].label)
            localStorage.setItem('comprtId', data[num].label)
          } else {
            commit('SET_COMPET_ID', '')
            localStorage.setItem('comprtId', '')
          }
          resolve(data[num].label)
        }).catch(error => {
          reject(error)
        })
      })
    },
    userLogout({ commit, state }) {
      return logout().then((res) => {
        if (res.code === 0) {
          removeToken()
          removeUserId();
          removeUserName();
          removeUserType();
          commit('SET_COMPRT_ID', '')
          localStorage.setItem('comprtId', '')
        }
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js